import { useState } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent } from "@/components/ui/card";
import { Phone, CreditCard } from "lucide-react";

const ContactSection = () => {
  const ref = useScrollReveal();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Future: send to backend
    alert("הטופס נשלח בהצלחה! ניצור איתך קשר בהקדם.");
    setName("");
    setPhone("");
    setService("");
  };

  return (
    <section id="contact" className="py-20 bg-background" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Lead Form */}
          <div className="animate-on-scroll">
            <Card className="border-border shadow-lg">
              <CardContent className="p-8">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
                  צרו <span className="text-primary">קשר</span>
                </h2>
                <p className="text-muted-foreground mb-6">השאירו פרטים ונחזור אליכם תוך שעות ספורות</p>

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground mb-1">שם מלא</label>
                    <Input
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="הזינו את שמכם"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-foreground mb-1">טלפון</label>
                    <Input
                      id="phone"
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="054-572-5681"
                      required
                      dir="ltr"
                      className="text-right"
                    />
                  </div>
                  <div>
                    <label htmlFor="service" className="block text-sm font-medium text-foreground mb-1">סוג שירות</label>
                    <Select value={service} onValueChange={setService}>
                      <SelectTrigger id="service" aria-label="סוג שירות">
                        <SelectValue placeholder="בחרו שירות" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="leaks">איתור ותיקון נזילות</SelectItem>
                        <SelectItem value="construction">בנייה קלה</SelectItem>
                        <SelectItem value="gutters">מרזבים</SelectItem>
                        <SelectItem value="metal">פחחות</SelectItem>
                        <SelectItem value="ventilation">אוורור גגות</SelectItem>
                        <SelectItem value="other">אחר</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <Button type="submit" className="w-full bg-primary text-primary-foreground hover:bg-gold-light font-bold text-lg py-6">
                    <Phone size={18} />
                    שלחו פנייה
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          {/* Payment Section */}
          <div className="animate-on-scroll flex flex-col justify-center" style={{ transitionDelay: "200ms" }}>
            <Card className="border-primary/30 bg-dark shadow-lg">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="text-primary" size={32} />
                </div>
                <h3 className="text-xl font-bold text-dark-foreground mb-3">ביקור וייעוץ מקצועי</h3>
                <p className="text-dark-foreground/80 leading-relaxed mb-6">
                  ביקור מקצועי כולל סקירה מקיפה של הגג, אבחון בעיות ותוכנית פעולה מפורטת.
                  <br />
                  <strong className="text-primary">התשלום נגבה מראש</strong> ומהווה חלק מהשקעתכם באיכות.
                </p>
                <Button className="w-full bg-primary text-primary-foreground hover:bg-gold-light font-bold text-lg py-6">
                  <CreditCard size={18} />
                  לתשלום עבור ביקור מקצועי
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
